import { styled } from "@mui/material/styles";
import { Box, Button, Card, Typography, Pagination } from "@mui/material";
import colors from "../../theme/Colours";

export const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  paddingTop: theme.spacing(1),
  borderRadius: theme.shape.borderRadius * 1.5,
  backgroundColor: colors.background2,
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  width: "180px",
  height: "45px",
  border: `1px solid ${colors.primaryButtonOrange}`,
  backgroundColor: colors.primaryButtonOrange,
  color: colors.background2,
  boxShadow: "none",
  borderRadius: theme.shape.borderRadius,
  "&:hover": {
    backgroundColor: colors.primaryButtonOrangeHover,
    color: colors.background2,
    boxShadow: "none",
  },
  [theme.breakpoints.down("sm")]: {
    width: "140px",
  },
}));

export const ExportButton = styled(Button)(({ theme }) => ({
  width: "120px",
  height: "45px",
  border: `1px solid ${colors.disabledGrey}`,
  backgroundColor: colors.background2,
  color: colors.searchInputText,
  boxShadow: "none",
  borderRadius: theme.shape.borderRadius,
  gap: theme.spacing(1),
  "&:hover": {
    boxShadow: "none",
    backgroundColor: colors.lightBackground,
  },
  [theme.breakpoints.down("sm")]: {
    width: "100px",
  },
}));

export const PaginationContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: colors.background2,
  marginTop: theme.spacing(1),
  padding: theme.spacing(2.5),
}));

export const PaginationCaption = styled(Typography)(({ theme }) => ({
  color: colors.greyTypography,
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem",
  },
}));

export const StyledPagination = styled(Pagination)(() => ({
  "& .MuiPaginationItem-root": {
    color: colors.searchInputText,
  },
  "& .MuiPaginationItem-page.Mui-selected": {
    backgroundColor: colors.primaryButtonOrange,
    color: colors.background2,
  },
}));

export const HeaderTableRow = {
  borderTop: `2px solid #E9E9E9`,
};

export const greyTextStyle: React.CSSProperties = {
  color: colors.tableFieldText,
};
